export default {
  toggle: function (selector, prop, from, to) {
    const el = document.querySelector(selector);
    if (getComputedStyle(el)[prop] == from) el.style[prop] = to;
    else el.style[prop] = from;
  },
  tranStatus: function (value) {
    const status = {
      pending: 'En attente',
      processing: 'En cours',
      completed: 'Terminee',
      canceled: 'Annulee',
    };
    return status[value];
  },
  getCountryCode: function (countryCode) {
    if (countryCode) {
      return (
        'https://static.dwcdn.net/css/flag-icons/flags/4x3/' +
        countryCode.toLowerCase() +
        '.svg'
      );
    }
  },
  getCountryNameByCode: function (data, Code) {
    for (var prop in data) {
      if (data.hasOwnProperty(prop)) {
        if (data[prop]['code'] === Code) {
          return data[prop]['name'];
        }
      }
    }
  },
  getTimezonesByCode: function (data, Code) {
    for (var prop in data) {
      if (data.hasOwnProperty(prop)) {
        if (data[prop]['code'] === Code) {
          return data[prop];
        }
      }
    }
  },
  getcurrencyCodeByCountry: function (data, country) {
    for (var prop in data) {
      if (data.hasOwnProperty(prop)) {
        if (data[prop]['code'] === country) {
          return data[prop]['currencyCode'];
        }
      }
    }
  },
  getCountryCodeByName: function (data, Name) {
    for (var prop in data) {
      if (data.hasOwnProperty(prop)) {
        if (data[prop]['name'] === Name) {
          return data[prop]['code'];
        }
      }
    }
  },
  objectToQueryString: function (obj) {
    var str = [];
    var s = document.location.search;
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(
          encodeURIComponent(p) +
          '=' +
          encodeURIComponent(obj[p]).replace(/%2C/g, ','),
        );
      }
    window.history.pushState('', '', '?' + str.join('&'));
  },
  objectToQueryLink: function (obj, prefix) {
    var str = [],
      p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + '[' + p + ']' : p,
          v = obj[p];
        str.push(
          v !== null && typeof v === 'object'
            ? serialize(v, k)
            : encodeURIComponent(k) + '=' + encodeURIComponent(v),
        );
      }
    }
    return str.join('&');
  },
  QueryStringToobject: function () {
    var search = location.search.substring(1);
    if (search)
      return JSON.parse(
        '{"' +
        decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}',
      );
    else return null;
  },
  getAccess: function (permissions, modelToCheck, accessToCheck) {
    for (let i in permissions) {
      let model = permissions[i]['model'];
      let access = permissions[i]['access'];

      if (model == modelToCheck) {
        return access[accessToCheck];
      }
    }
  },
  getAccessPermission: function (user, modelToCheck, accessToCheck) {
    if (user && user.role && user.role.permissions) {
      const permissions = user.role.permissions;
      for (let i in permissions) {
        let model = permissions[i]['model'];
        let access = permissions[i]['access'];

        if (model == modelToCheck) {
          return access[accessToCheck];
        }
      }
    }
  },
  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  },
};